<template>
    <section class="my-0">
        <div class="d-flex justify-content-start">
            <div class="col px-0">

                <div class="card mb-3 bg-dark">
                    <div class="card-body" >
                        <p class="h3">Book unique hostels.</p>
                        <form>
                            <div class="form-group">
                                <label for="exampleInputEmail1">Location</label>
                                <input type="email" class="form-control" id="exampleInputEmail1" aria-describedby="emailHelp" placeholder="Where">
                                <label for="exampleFormControlSelect1">Number in a Room</label>
                                <select class="form-control" id="exampleFormControlSelect1">
                                    <option>1</option>
                                    <option>2</option>
                                    <option>3</option>
                                    <option>4</option>
                                </select>
                            </div>
                            <button type="submit" class="btn btn-info">Search</button>
                        </form>
                    </div>
                </div>

            </div>
        </div>
    </section>
</template>
<script>
    export default {};
</script>
<style>
</style>
